<template>
    <div>
        <v-autocomplete
            v-model="city"
            :items="cities"
            :item-value="itemValue"
            item-text="name"
            :label="label"
            outlined
            dense
            :color="inputColor"
            :background-color="backgroundColor"
            :loading="loading"
            :readonly="readonly"
            :clearable="!readonly"
            :rules="rules"
            hide-details="auto"
            @input="input"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData.js";
import {ref, watch} from "vue";
import axios from "axios";

export default {
    name: "WCountryCityAutocomplete",
    props: {
        value: [Number, String],
        readonly: Boolean,
        label: String,
        rules: Array,
        itemValue: String,
        stateId: Number,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const city = ref(null);
        const cities = ref([]);

        function findAll() {
            loading.value = true;
            axios.get(`/countryCities/state/${props.stateId}`).then(response => {
                cities.value = response.data;
            }).finally(() => {
               loading.value = false;
            });
        }

        function input(value) {
            emit('input', value);
        }

        watch(() => props.stateId, () => {
           if (props.stateId) {
               findAll();
           }
        }, {immediate: true});

        watch(() => props.value, () => {
            city.value = props.value;
        }, {immediate: true});

        return {
            loading,
            inputColor,
            backgroundColor,
            city,
            cities,
            input,
        }

    },
}
</script>

<style scoped>

</style>